import React from 'react';

export const StickyNote = ({
  title = '',
  bgColor = '#FDF5E9',
  color = '#363636',
  type = 'normal',
  padding = 10,
  subtitle = '',
  subtitleColor = '#4F4F4F',
}) => {
  if (!title.length) return null;
  return (
    <div
      className='sticky_note col'
      style={{
        background: bgColor,
        padding: padding,
      }}
    >
      <p
        className='sticky_note_title'
        style={{
          color: color,
          fontWeight: type,
        }}
      >
        {title}
      </p>
      {subtitle && (
        <p
          className='sticky_note_title'
          style={{
            color: subtitleColor,
            fontWeight: type,
          }}
        >
          {subtitle}
        </p>
      )}
    </div>
  );
};
